import { createUseQueryEntry } from "./client";

export interface ContentfulMicrocopyFields {
	key: string;
	value: string;
}

export const CONTENTFUL_ENTRY_WELCOME_NUMBER_OF_INTEGRATIONS = "3XDmR39NJ0JngnH8tnJQrf";
export const useQueryWelcomeNumberOfIntegrations = createUseQueryEntry<ContentfulMicrocopyFields>(
	CONTENTFUL_ENTRY_WELCOME_NUMBER_OF_INTEGRATIONS,
);

export const CONTENTFUL_ENTRY_TOP_NAV_CTA_INTRO_TEXT = "1BayytReADXktlZIWoask4";
export const useQueryTopNavCtaIntroText = createUseQueryEntry<ContentfulMicrocopyFields>(
	CONTENTFUL_ENTRY_TOP_NAV_CTA_INTRO_TEXT,
);
